import {
  ISubmissionFile,
  ISubmissionFileSet
} from '@publishing-engine/domain/models';

const IGNORED_FILE_FIELDS = new Set([
  'ConsolidatedPdf',
  'AnonymizedConsolidatedPdf',
  'ConsolidatedPdfJob',
  'StandardReportingGuidelinesFileDetails'
]);

export type FileEntry = { category: string; file: ISubmissionFile };

export const getFiles = (fileSet?: ISubmissionFileSet): FileEntry[] => {
  const files: FileEntry[] = [];
  const visit = (value: unknown, category: string) => {
    if (Array.isArray(value)) {
      value.forEach(item => visit(item, category));
      return;
    }
    if (!value || typeof value !== 'object') return;

    const record = value as Record<string, unknown>;
    if (typeof record.url === 'string' && typeof record.name === 'string') {
      files.push({ category, file: record as ISubmissionFile });
      return;
    }
    Object.values(record).forEach(nested => visit(nested, category));
  };

  Object.entries(fileSet ?? {}).forEach(([category, value]) => {
    if (IGNORED_FILE_FIELDS.has(category)) return;
    visit(value, category);
  });

  return files;
};

const sortObjectKeys = (value: unknown): unknown => {
  if (Array.isArray(value)) return value.map(sortObjectKeys);
  if (!value || typeof value !== 'object') return value;

  return Object.keys(value as Record<string, unknown>)
    .sort()
    .reduce<Record<string, unknown>>((result, key) => {
      result[key] = sortObjectKeys((value as Record<string, unknown>)[key]);
      return result;
    }, {});
};

export const getSourceFileSetSignature = (fileSet?: ISubmissionFileSet) => {
  return JSON.stringify(sortObjectKeys(getFiles(fileSet)));
};
